/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';

import './style.scoped.scss';
import { FaAngleDown, FaAngleUp } from 'react-icons/fa';
import {
  getSectionRelationships,
  getDocumentRelationships,
  setCurrentDocument,
} from '../../../store/Document/documentActions';
import Loader from '../../Loader';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../assets/constants/strings';

const RelatedSections = ({
  relatedSections,
  relatedDocuments,
  documents,
  currentDoc,
  currentPage,
  loading,
  getDocumentRelationships,
  getSectionRelationships,
  setCurrentDocument,
}) => {
  const [arrowList, setArrowList] = useState([]);
  const [localRelatedDocuments, setLocalRelatedDocuments] = useState([]);

  const handleArrowClick = (id) => {
    $(`#RelatedDocumentsList-${id}`).collapse('toggle');

    const list = [...arrowList];
    list.filter((arrow) => arrow === id).length > 0
      ? setArrowList(list.filter((arrow) => arrow !== id))
      : setArrowList([...list, id]);
  };

  const renderIcon = (id) => {
    return arrowList.filter((arrow) => arrow === id).length > 0 ? (
      <FaAngleUp onClick={() => handleArrowClick(id)} />
    ) : (
      <FaAngleDown onClick={() => handleArrowClick(id)} />
    );
  };

  useEffect(() => {
    setArrowList([]);
    if (relatedSections && relatedSections.length > 0) {
      const allRelatedDocIDs = []; // empty arr

      relatedSections.forEach((relatedSection) => {
        allRelatedDocIDs.push(relatedSection.RelatedDocumentId); // populate with doc ids
      });

      const uniqueIDsArray =
        allRelatedDocIDs.length > 1
          ? allRelatedDocIDs
              .filter(
                (value, index) => allRelatedDocIDs.indexOf(value) === index
              ) // remove duplicates
              .sort((a, b) => (a > b ? 1 : -1))
          : allRelatedDocIDs; // if it only has one type, it will remove from array

      const relatedDocsArray = [];

      uniqueIDsArray.forEach((id) => {
        const thisDocInState = documents.filter((doc) => doc.id === id)[0];

        // Check if thisDocInState is defined
        if (thisDocInState) {
          relatedDocsArray.push({
            isParent: currentDoc.id === thisDocInState.id,
            doc1Id: currentDoc.id,
            doc1Title: currentDoc.title,
            doc2Id: thisDocInState.id,
            doc2Title: thisDocInState.title,
          });
        }
      });

      setLocalRelatedDocuments(relatedDocsArray);
    }
  }, [relatedSections]);

  useEffect(() => {
    setArrowList([]);

    if (
      (relatedDocuments === null || relatedDocuments === undefined) &&
      !loading
    )
      getDocumentRelationships(currentDoc.id);

    if ((relatedSections === null || relatedSections === undefined) && !loading)
      getSectionRelationships(currentPage, currentDoc.pages);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [relatedSections, currentPage, currentDoc, loading]);

  if (
    loading ||
    !relatedDocuments ||
    !relatedSections ||
    !localRelatedDocuments
  ) {
    return <Loader card />;
  } else if (!relatedSections || relatedSections.length < 1) {
    return <p className='mb-0'>No related sections</p>;
  } else
    return (
      <div id='RelatedDocumentsGroup'>
        {localRelatedDocuments.map((relatedDocument) => {
          if (
            relatedSections.filter(
              (section) => section.RelatedDocumentId === relatedDocument.doc2Id
            ).length > 0
          )
            return (
              <div key={relatedDocument.doc2Id} className='w-100'>
                <div
                  className='d-flex justify-content-between align-items-center'
                  onClick={() => handleArrowClick(relatedDocument.doc2Id)}
                >
                  <div className='wf-word-wrap hover'>
                    <p className='m-0' title={relatedDocument.doc2Title}>
                      {relatedDocument.doc2Title}
                    </p>
                  </div>
                  {renderIcon(relatedDocument.doc2Id)}
                </div>

                <div
                  id={`RelatedDocumentsList-${relatedDocument.doc2Id}`}
                  className='collapse pl-4'
                  // data-parent="#RelatedDocumentsGroup"
                >
                  <div className='d-flex flex-column pl-2'>
                    {relatedSections
                      .filter(
                        (doc) =>
                          doc.RelatedDocumentId === relatedDocument.doc2Id
                      )
                      .sort((a, b) =>
                        a.RelatedPageTitle.localeCompare(
                          b.RelatedPageTitle,
                          undefined,
                          { numeric: true }
                        )
                      )
                      .map((page, index) => (
                        <Link
                          key={index}
                          to={ROUTES.DOCUMENT(
                            page.RelatedDocumentSlug,
                            page.RelatedPageSlug
                          )}
                          target='_blank'
                          rel='noreferrer'
                        >
                          <div className='wf-word-wrap hover related-sections-item'>
                            <p title={page.RelatedPageTitle}>
                              {page.RelatedPageTitle}
                            </p>
                          </div>
                        </Link>
                      ))}
                  </div>
                </div>
              </div>
            );
          else return null;
        })}
      </div>
    );
};

const mapStateToProps = (state) => ({
  relatedSections: state.document.relatedPages,
  relatedDocuments: state.document.relatedDocuments,

  currentDoc: state.document.currentDocument,
  currentPage: state.document.currentPage,

  loading: state.document.loading,
  documents: state.client.documents,
});

const mapDispatchToProps = {
  getSectionRelationships,
  getDocumentRelationships,
  setCurrentDocument,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export default connector(RelatedSections);
